import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Feature, FeatureService, FeatureType } from 'src/app/services/feature/feature.service';
import { ModalService } from 'src/app/services/modal/modal.service';

interface SelectValue {
  value: FeatureType;
  label: string;
}

@Component({
  selector: 'app-feature-flipping',
  templateUrl: './feature-flipping.component.html',
  styleUrls: ['./feature-flipping.component.scss']
})
export class FeatureFlippingComponent implements OnInit {

  public dataSource: Array<Feature> = [];
  public displayedColumns: string[] = ['featureLabel', 'featureDescription', 'featureValueTrue', 'featureValueFalse'];
  public granularities: Array<SelectValue>;

  public displayType: FeatureType;
  public typeTmpl = FeatureType;
  public type: FeatureType | 'ALL';
  private _targetId: string;

  constructor(
    private _modalSrv: ModalService,
    private _view: ViewContainerRef,
    private _featureSrv: FeatureService,
    private _route: ActivatedRoute,
  ) { }

  async ngOnInit(): Promise<void> {
    this.displayType = this._route.snapshot?.queryParams?.type;
    this._targetId = this._route.snapshot?.queryParams?.id;

    if (this.displayType && !this._targetId) {
      this._modalSrv.openAlert(
        this._view, 'Erreur', 'L\'id de la cible est manquant',
      );
      return;
    } else if (!this.displayType) {
      this.displayType = FeatureType.GLOBAL;
    }

    if (this.displayType === FeatureType.GLOBAL) {
      this.type = 'ALL';
      const index = 2;
      const newDisplay = [
        ...this.displayedColumns.slice(0, index),
        'featureGranularity',
        ...this.displayedColumns.slice(index)
      ];
      this.displayedColumns = newDisplay;
      
      this.granularities = [
        { value: FeatureType.GLOBAL, label: 'Global' },
        { value: FeatureType.CABINET, label: 'Cabinet' },
        { value: FeatureType.PROFIL, label: 'Profil' },
      ];
    } else {
      this.type = this.displayType;
    }

    await this._initData();
  }

  private async _initData(): Promise<void> {
    try {
      this.dataSource = await this._featureSrv.getAllFeatures(this.type, this._targetId);
    } catch (error) {
      console.error(error);
      this._modalSrv.openAlert(
        this._view, 'Erreur', error?.message || error,
      );
    }
  }

  public changeValue(feature: Feature, value: boolean): void {
    feature.value = value;
  }

  public test(feature: Feature): SelectValue {
    switch (feature.type) {
      case FeatureType.GLOBAL:
        return this.granularities[0];
      case FeatureType.CABINET:
        return this.granularities[1];
      case FeatureType.PROFIL:
        return this.granularities[2];
      default:
        return this.granularities[0];
    }
  }

  public async updateFeatures(): Promise<void> {
    try {
      await this._featureSrv.updateFeatures(this.dataSource, this.displayType, this._targetId);
      await this._initData();
    } catch (error) {
      console.error(error);
      this._modalSrv.openAlert(
        this._view, 'Erreur', error?.message || error,
      );
    }
  }
}
